import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import CopyrightIcon from "@material-ui/icons/Copyright"

const useStyles = makeStyles(theme => ({
  appBar: {
    top: "auto",
    bottom: 0,
    zIndex: 998,
    left: 0,
    width: "inherit",
  },
  typography: {
    width: "100%",
  },
  copyright: {
    verticalAlign: "middle",
    marginRight: theme.spacing(0.5),
  },
}))

const Footer = () => {
  const classes = useStyles()
  return (
    <AppBar position="fixed" color="primary" className={classes.appBar}>
      <Toolbar>
        <Typography
          variant="body2"
          align="center"
          className={classes.typography}
        >
          <CopyrightIcon fontSize="inherit" className={classes.copyright} />
          {new Date().getFullYear()} Copyright Omnichannel
        </Typography>
      </Toolbar>
    </AppBar>
  )
}

export default Footer
